<template>
  <div class="about">
    <h1 class="page-header">
      About
      <template v-if="$store.state.country == 'us'"
        >Ne'eman Foundation
      </template>
      <template v-else>The Emunim Fund</template>
    </h1>

    <div class="card card-row shadow-light-lg mb-6">
      <div class="row no-gutters">
        <div
          class="col-12 col-md-6 order-md-2 bg-cover card-img-right did-you-know"
        >
          <img
            :src="require('../assets/img/charity_growth.jpg')"
            alt="..."
            class="img-fluid d-md-none invisible"
          />
          <div
            class="shape shape-left shape-fluid-y svg-shim text-white d-none d-md-block"
          >
            <svg
              viewBox="0 0 112 690"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 0h62.759v172C38.62 384 112 517 112 517v173H0V0z"
                fill="currentColor"
              ></path>
            </svg>
          </div>
        </div>
        <div class="col-12 col-md-6 order-md-1">
          <div class="card-body">
            <h2>Did you know…</h2>
            <template v-if="$store.state.country == 'us'">
              <p class="mb-0 text-muted">
                American support has generously increased in response to the
                growing needs of the Israeli community.
              </p>
              <p class="mb-0 text-muted">
                Now there is a U.S. organization dedicated to providing a secure
                financial link between the two countries in addition to helping
                Israeli non-profit organization build a new donor base in the
                U.S. or strengthen an existing one.
              </p>
            </template>
            <template v-else>
              <p class="mb-0 text-muted">
                Canadian support has generously increased in response to the
                growing needs of the Israeli community.
              </p>
              <p class="mb-0 text-muted">
                Now there is a Canadian organization dedicated to providing a
                secure financial link between the two countries in addition to
                helping Israeli non-profit organization build a new donor base
                in Canada or strengthen an existing one.
              </p>
            </template>
          </div>
        </div>
      </div>
    </div>

    <who-we-are />

    <div class="card card-row shadow-light-lg mb-6">
      <div class="row no-gutters">
        <div class="col-12 col-md-6 order-md-2 bg-cover card-img-right poverty">
          <img
            :src="require('../assets/img/poverty.jpg')"
            alt="..."
            class="img-fluid d-md-none invisible"
          />
          <div
            class="shape shape-left shape-fluid-y svg-shim text-white d-none d-md-block"
          >
            <svg
              viewBox="0 0 112 690"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 0h62.759v172C38.62 384 112 517 112 517v173H0V0z"
                fill="currentColor"
              ></path>
            </svg>
          </div>
        </div>
        <div class="col-12 col-md-6 order-md-1">
          <div class="card-body">
            <h2>What we do</h2>
            <template v-if="$store.state.country == 'us'">
              <p class="mb-0 text-muted">
                Ne’eman Foundation USA supports projects that reduce or
                eliminate poverty, advance education, religion and quality of
                life, and promotes charitable initiatives for community
                development in Israeli communities. Additionally, we support
                projects throughout Israel that provide health care services and
                products that prevent and manage serious threats to health.
              </p>
            </template>
            <template v-else>
              <p class="mb-0 text-muted">
                The Emunim Fund supports projects that reduce or eliminate
                poverty, advance education, religion and quality of life, and
                promote charitable initiatives for community development in
                Israeli communities. Additionally, we support projects
                throughout Israel that provide health care services and products
                that prevent and manage serious threats to health; projects that
                provide therapy to accident victims, as well as counseling and
                support to individuals with cancer. The Ne’eman Foundation also
                supports programs that provide Israeli public ambulance,
                paramedic, or firefighting services.
              </p>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-2 d-none d-lg-block">
            <div class="avatar avatar-xxl">
              <img
                src="../assets/img/haim_katz_neeman_2.jpg"
                alt="Chaim Katz"
                class="avatar-img rounded-circle"
              />
            </div>
            <p class="wp-caption-text">
              Chaim Katz, CEO of the Ne’eman Foundation
            </p>
          </div>
          <div class="col-md-10">
            <h2>
              <strong>Chaim Katz, CEO of Ne’eman Foundation </strong>
            </h2>
            <p class="mb-0 text-muted">
              A native Canadian and resident of Israel since 1987, Chaim’s
              distinguished record of service in public and non-profit
              organizations spans nearly 40 years.
            </p>
            <p class="mb-0 text-muted">
              In the 1980’s, Chaim served as Director of a Jewish Agency
              sponsored Aliyah organization in New York. This was followed by
              financial management positions in the Koch Administration for the
              City of New York, and financial investments for a non-profit
              city-wide social service agency.
            </p>
            <p class="mb-0 text-muted">
              Following his Aliyah, Chaim served in a variety of senior
              executive positions in the non-profit world as well as the private
              sector. He has dedicated many years to working on behalf of
              Special Needs children in Israel, as well as programs for families
              in financial distress. He also served as Mayor of the Village of
              Shilo for 5 years. Since 1991, Chaim has also volunteered his time
              as Treasurer of a local Free Loan Society in Israel.
            </p>
            <p class="mb-0 text-muted">
              Chaim’s experience and familiarity with the non-profit worlds of
              Israel and North America enable him to offer professional guidance
              and service to the Ne’eman Foundation and recipients in Israel.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import WhoWeAre from "../components/WhoWeAre";
export default {
  name: "About",
  metaInfo: {
    title: "About Us",
  },

  components: {
    WhoWeAre,
  },
};
</script>
<style lang="scss">
.did-you-know {
  background-image: url("~@/assets/img/charity_growth.jpg");
}
.poverty {
  background-image: url("~@/assets/img/poverty.jpg");
}
.who-we {
  background-image: url("~@/assets/img/boston.jpg");
}
</style>